module.exports = __webpack_public_path__ + "97f6c0fb1c124a87957c66904bd3f9d8.jpg";